import React from "react";
import {Icon} from "semantic-ui-react";

export const WarningBanner = ({warningText}) => {
    return (
        <div
            style={{
                display: "flex",
                flexDirection: "row",
                gap: 20,
                alignItems: "center",
                width: "100%",
                height: 80,
                borderRadius: 6,
                border: "2px solid #FF8E88",
                padding: 10,
                background: "#FFCDCB",
            }}
        >
            <Icon size="big" color="red" name="exclamation"/>
            <p style={{fontWeight: 600, fontSize: 20}}>
                {warningText}
            </p>
        </div>
    );
};

export default WarningBanner;